import React, { useEffect, useState } from "react";
import { Card, Stack } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";
import UserIcon from "../Assets/svg/cart-icon.svg";
import { useSelector } from "react-redux";
import { HiArrowUp, HiArrowDown } from "react-icons/hi";
import { formatNumberWithCommas } from "../utils/formatNumberWithCommas";

const QuotesGenerated = ({ title }) => {
  const { DashboardListingData } = useSelector(
    (state) => state.DASHBOARDLISTING
  );

  const chartData =
    DashboardListingData?.data?.generated_Quote?.six_month_data ?? {};

  const percentageValue = parseFloat(
    DashboardListingData?.data?.generated_Quote?.difference_in_percentage
  );
  const count =
    DashboardListingData?.data?.generated_Quote?.total_registered_count ?? 0;
  const totalCount =
    DashboardListingData?.data?.generated_Quote?.total_registered_count ?? 0;

  const [isDataLoaded, setIsDataLoaded] = useState(false);

  // State to manage the chart options and series
  const [chartState, setChartState] = useState({
    series: [
      {
        name: title,
        data: [],
      },
    ],
    options: {
      chart: {
        toolbar: {
          show: false,
        },
        type: "bar",
      },
      plotOptions: {
        bar: {
          distributed: true,
          borderRadius: 5,
          dataLabels: {
            enabled: false,
            position: "bottom",
            show: false,
          },
          columnWidth: "11px",
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        // formatter: (seriesName, opts) => {
        //   if (opts.seriesIndex) return "";
        //   return null;
        // },
        // markers: {
        //   width: [0, 0, 0, 0, 0, 0],
        // },
        show: false,
      },
      xaxis: {
        categories: [],
        position: "bottom",
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
        tooltip: {
          enabled: false,
        },
        labels: {
          style: {
            colors: "#8B8BA7",
            fontSize: "14px",
            fontWeight: 400,
          },
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
        },
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      colors: [],
    },
  });

  useEffect(() => {
    if (Object.keys(chartData).length > 0) {
      // Define colors for each bar: blue for the current month and default color for the others
      const defaultColor = "#99C3FF";
      const currentMonthColor = "#006AFF"; // Blue color for the current month

      const months = Object.keys(chartData);
      const counts = Object.values(chartData);

      // Determine colors for each bar in the filtered range
      const colors = months.map((_, index) =>
        index === months.length - 1 ? currentMonthColor : defaultColor
      );

      // Update the chart state
      setChartState((prevState) => ({
        ...prevState,
        series: [
          {
            name: title,
            data: counts,
          },
        ],
        options: {
          ...prevState.options,
          xaxis: {
            ...prevState.options.xaxis,
            categories: months,
          },
          colors: colors,
        },
      }));

      // Data is now loaded, set the state to true
      setIsDataLoaded(true);
    }
  }, [DashboardListingData]);

  return (
    <Card
      className="dashboard_cards flex-grow-1 h-100"
      style={{ border: "none" }}
    >
      <Card.Body className="d-flex flex-column row-gap-2 justify-content-between">
        <div className="d-flex flex-column row-gap-2">
          <Card.Title className="d-flex gap-2 text_gray m-0">
            <img src={UserIcon} alt="user-icon" width={24} /> {title}
          </Card.Title>
          <div>
            <span className="text_gray fw-bold" style={{ fontSize: "14px" }}>
              Total Quotes:
            </span>
            <span className="text_gray" style={{ fontSize: "14px" }}>
              {" "}
              {formatNumberWithCommas(totalCount)}
            </span>
          </div>
        </div>
        <div className="d-flex flex-wrap row-gap-2">
          <Stack className="justify-content-end gap-1">
            <h2
              style={{ fontSize: 32, fontWeight: "700", color: "#16161D" }}
              className="mb-0"
            >
              {formatNumberWithCommas(count ?? 0)}
            </h2>
            <p
              className={`${
                percentageValue === 0
                  ? "text-muted"
                  : percentageValue > 0
                  ? "text-success-color"
                  : "text-danger"
              } d-flex align-items-center rate-percentage-style gap-1 m-0`}
            >
              <span>{percentageValue.toFixed()}%</span>
              {percentageValue !== 0 && (
                <>
                  {percentageValue > 0 ? (
                    <HiArrowUp size={18} />
                  ) : (
                    <HiArrowDown size={18} />
                  )}
                </>
              )}
            </p>
          </Stack>
          <div id="chart">
            {/* Conditionally render the chart only when data is loaded */}
            {isDataLoaded && (
              <ReactApexChart
                options={chartState.options}
                series={chartState.series}
                type="bar"
                height={150}
                width={200}
              />
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default QuotesGenerated;
